import { Component } from '@angular/core';
import { AssetPipe } from '../../../../../../../../pipes/asset.pipe';
import { BaseSectionComponent } from '../base-section.component';

@Component({
    selector: 'app-section-interactivity',
    templateUrl: './section-interactivity.component.html',
    styleUrls: ['./section-interactivity.component.scss'],
    imports: [
        AssetPipe
    ],
    standalone: true
})
export class SectionInteractivityComponent extends BaseSectionComponent {

}